import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[restrictDotInput]'
})
export class RestrictDotInputDirective {
  constructor() { }
  @HostListener('keydown', ['$event']) onKeyDown(event: any) {
    let e = <KeyboardEvent>event;
    if (e.keyCode == 110) {
      e.preventDefault();
    } else {
      return;
    }
  }
}
